import styled from 'styled-components';

import { Content as ContentBase } from '~/components/modals/Modal';

export const Container = styled.div`
  width: 515px;
`;

export const Content = styled(ContentBase)`
  display: flex;
  padding-top: 10px;

  p {
    margin: 0;
  }
`;

export const Warning = styled.span`
  color: ${({ theme }) => theme.colors.status.failure};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
